export var importChiliPiper = function () {
    return new Promise(function (resolve, reject) {
        var script = document.createElement("script");
        script.type = "text/javascript";
        script.src = "https://js.chilipiper.com/marketing.js";
        script.addEventListener("load", function () { return resolve(script); }, false);
        script.addEventListener("error", function () { return reject(script); }, false);
        document.body.appendChild(script);
    });
};
